import { c as _c } from "react/compiler-runtime";
import { cva } from "class-variance-authority";
import { cn } from "@/utils";
import { Slot } from "./slot";
const buttonWrapperVariants = cva("inline-flex items-stretch rounded-4xl", {
  variants: {
    variant: {
      dark: " bg-neutral-800",
      light: "bg-neutral-200"
    },
    size: {
      small: "h-6 md:h-8",
      large: "h-8 md:h-10"
    }
  },
  defaultVariants: {
    variant: "dark",
    size: "large"
  }
});
const buttonInnerVariants = cva("inline-flex items-center justify-center rounded-4xl px-4 border bg-gradient-to-b w-full", {
  variants: {
    variant: {
      dark: "transition-colors border-neutral-700 from-neutral-900 to-neutral-700 text-white hover:from-neutral-800 hover:to-neutral-600 active:border-neutral-500",
      light: "border-neutral-200 from-neutral-200 to-neutral-50 text-neutral-800 hover:from-neutral-300 hover:to-neutral-100 active:border-neutral-200"
    },
    size: {
      small: "text-xs font-medium md:text-sm",
      large: "text-xs font-medium md:text-sm px-6"
    }
  },
  defaultVariants: {
    variant: "dark",
    size: "large"
  }
});
export const Button = t0 => {
  const $ = _c(15);
  const {
    children,
    variant,
    size,
    className,
    innerClassName,
    asChild
  } = t0;
  const Comp = asChild ? Slot : "button";
  let t1;
  if ($[0] !== className || $[1] !== size || $[2] !== variant) {
    t1 = cn(buttonWrapperVariants({
      variant,
      size,
      className
    }));
    $[0] = className;
    $[1] = size;
    $[2] = variant;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== innerClassName || $[5] !== size || $[6] !== variant) {
    t2 = cn(buttonInnerVariants({
      variant,
      size,
      className: innerClassName
    }));
    $[4] = innerClassName;
    $[5] = size;
    $[6] = variant;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== Comp || $[9] !== children || $[10] !== t2) {
    t3 = <Comp className={t2}>{children}</Comp>;
    $[8] = Comp;
    $[9] = children;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t1 || $[13] !== t3) {
    t4 = <span className={t1}>{t3}</span>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};